import { LoadableTasks } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function TasksPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableTasks isMyTask={false} />
    </>
  );
}
